export * from 'office-ui-fabric-react/lib/SwatchColorPicker';
